import React from "react";

import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  message,
  Modal,
  Row,
  Space,
  Table,
  Tabs,
  Typography,
} from "antd";
import Text from "antd/lib/typography/Text";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { categories } from "../../../../actions/categories";
import {
  AddTransactionField,
  companySetting,
  DeleteTransactionField,
  deleteTransactionField,
  getTransactionField,
  UpdateCompanyTransaction,
  updateCompanyTransaction,
  UpdateTransactionField,
  updateTransactionField,
} from "../../../../actions/companySettings";
import AddNewIcon from "../../../../assets/icons/add_new_white.png";
import DeleteIcon from "../../../../assets/icons/delete.png";
import EditIcon from "../../../../assets/icons/edit.png";
import { hasAccess, objectToFormData } from "../../../../utils";
import PageHeader from "../../../PageHeader";
import "./../../styles/setting.css";
import "./../Custom.css";
import AddExpenseField from "./AddExpenseField";
const { TabPane } = Tabs;
const { Title } = Typography;

const columns = [
  {
    title: "Field",
    dataIndex: "column_name",
    key: "column_name",
  },
  {
    title: "Column Type",
    dataIndex: "column_type",
    key: "column_type",
  },
];

message.config({
  maxCount: 3,
});
const Expenses = () => {
  // const [activeTab, setActiveTab] = React.useState('profile');
  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [modalType, setIsModalType] = React.useState("center");
  const [selectedId, setSelectedId] = React.useState("");
  const [editMode, setEditMode] = React.useState(false);

  const formik = useFormik({
    initialValues: {
      transaction_prefix: "",
      transaction_reminder: "",
      transaction_reminder_days: "",
      transaction_starts_with: "",
      edit_prepaid: "",
      enable_ereceipts: "",
      policy_violation: "",
    },
    onSubmit: (vals) => {
      const payload = {};
      [
        "transaction_prefix",
        "transaction_reminder",
        "transaction_reminder_days",
        "transaction_starts_with",
        "edit_prepaid",
        "enable_ereceipts",
        "policy_violation",
      ].forEach((item) => {
        payload[item] = vals[item];
      });

      dispatch(updateCompanyTransaction(objectToFormData({ ...payload })));
    },
  });

  const companySettingResponse = useSelector(
    (state) => state.companySetting.companySetting || {},
  );
  const updateCompanySettingResponse = useSelector(
    (state) => state.companySetting.updateCompanySetting || {},
  );

  const transactionFieldResponse = useSelector(
    (state) => state.companySetting.getTransactionField || {},
  );
  const deleteTransactionFieldResponse = useSelector(
    (state) => state.companySetting.deleteTransactionField || {},
  );
  const addTransactionFieldResponse = useSelector(
    (state) => state.companySetting.addTransactionField || {},
  );
  const updateTransactionFieldResponse = useSelector(
    (state) => state.companySetting.updateTransactionField || {},
  );
  const updateTransactionReportResponse = useSelector(
    (state) => state.companySetting.updateTransactionReport || {},
  );
  const { data: { response: { fields = [] } = {} } = {} } =
    transactionFieldResponse;
  const setTab = () => {};

  React.useEffect(() => {
    dispatch(companySetting({}));
    dispatch(getTransactionField({}));
    dispatch(
      categories({
        status: true,
      }),
    );
    // setIsModalVisible(false,);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data: { response: { company_setting = {} } = {} } = {} } =
    companySettingResponse;
  React.useEffect(() => {
    formik.resetForm();
    const { data: { status = false } = {} } = companySettingResponse;
    // setCompanyValues({...company_setting});
    if (status) {
      formik.setValues({
        transaction_prefix: company_setting.transaction_prefix,
        transaction_reminder: company_setting.transaction_reminder,
        transaction_reminder_days: company_setting.transaction_reminder_days,
        transaction_starts_with: company_setting.transaction_starts_with,
        edit_prepaid: company_setting.edit_prepaid,
        enable_ereceipts: company_setting.enable_ereceipts,
        policy_violation: company_setting.policy_violation,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companySettingResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = updateCompanySettingResponse;
    if (status) {
      dispatch({
        type: UpdateCompanyTransaction.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: UpdateCompanyTransaction.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCompanySettingResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      updateTransactionReportResponse;
    if (status) {
      dispatch(companySetting({}));
      handleSubmit();
      dispatch({
        type: UpdateCompanyTransaction.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTransactionReportResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = updateTransactionFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getTransactionField({}));
      dispatch({
        type: UpdateTransactionField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: UpdateTransactionField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTransactionFieldResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = deleteTransactionFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getTransactionField({}));
      dispatch({
        type: DeleteTransactionField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: DeleteTransactionField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteTransactionFieldResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = addTransactionFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getTransactionField({}));
      dispatch({
        type: AddTransactionField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: AddTransactionField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addTransactionFieldResponse]);

  const handleEdit = () => {
    setEditMode(true);
  };

  const handleSubmit = () => {
    setEditMode(false);
  };

  const tableAction = [
    {
      title: "Mandatory",
      dataIndex: "is_required",
      key: "is_required",
      render: (status, record) => (
        <Checkbox
          key={record.id}
          disabled={!hasAccess("expense_settings", "write")}
          onChange={(e) =>
            dispatch(
              updateTransactionField(
                objectToFormData({
                  ...record,
                  is_required: e.target.checked,
                }),
              ),
            )
          }
          checked={status}
        ></Checkbox>
      ),
    },
    // {
    //   title: "Show in PDF",
    //   dataIndex: "view_in_pdf",
    //   key: "view_in_pdf",
    //   render: (status, record) => (
    //     <Checkbox
    //       key={record.id}
    //       disabled={!hasAccess("expense_settings", "write")}
    //       onChange={(e) =>
    //         dispatch(
    //           updateTransactionField(
    //             objectToFormData({
    //               ...record,
    //               view_in_pdf: e.target.checked,
    //             })
    //           )
    //         )
    //       }
    //       checked={status}
    //     ></Checkbox>
    //   ),
    // },
    {
      title: "Enable",
      dataIndex: "is_enable",
      key: "is_enable",
      render: (status, record) => (
        <Checkbox
          key={record.id}
          disabled={!hasAccess("expense_settings", "write")}
          onChange={(e) =>
            dispatch(
              updateTransactionField(
                objectToFormData({ ...record, is_enable: e.target.checked }),
              ),
            )
          }
          checked={status}
        ></Checkbox>
      ),
    },
    {
      title: "Actions",
      key: "action",
      render: (text, record) => (
        <Space key={record.id} size="middle">
          <button
            disabled={!hasAccess("expense_settings", "write")}
            onClick={() => showEditModal(record.id)}
          >
            <img src={EditIcon} alt={"logo"} className="action-logo" />
          </button>
          <button
            disabled={!hasAccess("expense_settings", "write")}
            onClick={() => showDeleteModal(record.id)}
          >
            <img src={DeleteIcon} alt={"logo"} className="action-logo" />
          </button>
        </Space>
      ),
    },
  ];

  const showModal = () => {
    setSelectedId("");
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showDeleteModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("center");
  };

  const showEditModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const renderDeleteOption = () => {
    return (
      <>
        <Text>Are you sure you want to delete this field?</Text>
        <br />
        <Button
          key="1"
          className="formButton mt1"
          onClick={() =>
            dispatch(
              deleteTransactionField(objectToFormData({ id: selectedId })),
            )
          }
        >
          Delete
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </>
    );
  };

  return (
    <>
      {isModalVisible && (
        <Modal
          title={
            modalType === "center" ? (
              <>
                <img src={DeleteIcon} alt={"logo"} className="action-logo" />{" "}
                Delete Field
              </>
            ) : (
              <Title level={4}>
                {selectedId ? "Edit Fields" : "Add Fields"} &nbsp;
                <span className="text-small">Enter details and submit</span>
              </Title>
            )
          }
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={[]}
          className={
            modalType === "center"
              ? "center-aligned-modal"
              : "right-alinged-modal"
          }
        >
          {modalType === "center" ? (
            renderDeleteOption()
          ) : (
            <AddExpenseField id={selectedId} handleCancel={handleCancel} />
          )}
        </Modal>
      )}
      <div className="heading-div">
        <PageHeader
          title={`Expenses`}
          navigation={{
            Home: "/dashboard/",

            Customisation: "/setting/customisation/",
            Expenses: null,
          }}
        />
      </div>
      <Tabs onChange={setTab} type="card" size="large" className="custom-tabs">
        <TabPane tab="Preferences" key="preferences">
          <div className="tabContentWrapper">
            <Title level={5}>Auto-generate Expense ID</Title>
            <Divider />
            <Form
              layout="vertical"
              className="custom-form"
              onFinish={formik.handleSubmit}
              // validateMessages={validateMessages1}
            >
              <Row>
                <Col span={8}>
                  <Form.Item label="Prefix">
                    <Input
                      name="transaction_prefix"
                      onChange={formik.handleChange}
                      placeholder=""
                      value={formik.values.transaction_prefix}
                      disabled={!editMode || company_setting.transaction_prefix}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} className="ml1">
                  <Form.Item label="Start with">
                    <Input
                      placeholder=""
                      name="transaction_starts_with"
                      value={formik.values.transaction_starts_with}
                      // onChange={formik.handleChange}
                      onChange={(e) => {
                        if (Number.isNaN(Number(e.target.value))) {
                          return;
                        }
                        formik.setFieldValue(
                          "transaction_starts_with",
                          e.target.value,
                        );
                      }}
                      disabled={
                        !editMode || company_setting.transaction_starts_with
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Title level={5} className="customTitle">
                Notifications
              </Title>
              <Divider />
              <Row>
                <Col span={24}>
                  <Form.Item
                    valuePropName="checked"
                    style={{ marginBottom: "0px" }}
                  >
                    <Checkbox
                      checked={formik.values.transaction_reminder}
                      name="transaction_reminder"
                      disabled={!editMode}
                      onChange={(e) => {
                        formik.setFieldValue(
                          "transaction_reminder",
                          e.target.checked,
                        );
                      }}
                    >
                      <span className="flexDisplay">
                        Send reminders for unreported expenses for more than
                        &nbsp;
                        <Form.Item className="shortNumberInput">
                          <Input
                            type="text"
                            className="shortInput"
                            name="transaction_reminder_days"
                            disabled={!editMode}
                            value={formik.values.transaction_reminder_days}
                            onChange={(e) => {
                              if (Number.isNaN(Number(e.target.value))) {
                                return;
                              }
                              formik.setFieldValue(
                                "transaction_reminder_days",
                                e.target.value,
                              );
                            }}
                          />
                        </Form.Item>{" "}
                        &nbsp;days
                      </span>
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>

              {/* <Title level={5} className="customTitle">
                Settings
              </Title>
              <Divider />
              <Row>
                <Col span={24}>
                  <Form.Item name="enable_ereceipts" valuePropName="checked">
                    <Checkbox>
                      Enable Forward E-Receipts from Primary/Secondary Email ids
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name="policy_violation" valuePropName="checked">
                    <Checkbox>
                      Do not allow the employees to submit expenses if he
                      violate the policies
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>

              <Title level={5} className="customTitle">
                Cards
              </Title>
              <Divider />
              <Row>
                <Col span={24}>
                  <Form.Item name="edit_prepaid" valuePropName="checked">
                    <Checkbox>
                      Permit users to edit the amount in prepaid card expenses
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row> */}

              {!editMode && hasAccess("expense_settings", "write") && (
                <Button className="formButton mt3" onClick={() => handleEdit()}>
                  Edit
                </Button>
              )}
              {editMode && (
                <Button
                  key="5"
                  className="formButton mt3"
                  htmlType="submit"
                  disabled={updateTransactionReportResponse?.loading}
                >
                  Save
                </Button>
              )}
              {/* <Button key="6" className="cancelButton ml1 mt3" onClick={() => history.push(RouteConstants.SETTING_USERS)}></Button> */}
            </Form>
          </div>
        </TabPane>
        <TabPane tab="Fields" key="fields">
          <div className="tabContentWrapper">
            {hasAccess("expense_settings", "write") && (
              <Button onClick={showModal} className="mb1 addNew">
                <img src={AddNewIcon} alt={"logo"} className="addNew-logo" />
                New Field
              </Button>
            )}
            <Table
              rowKey="id"
              columns={[...columns, ...tableAction]}
              dataSource={fields}
              className="settingsTable"
            />
          </div>
        </TabPane>
      </Tabs>
    </>
  );
};

export default Expenses;
